import { module } from 'modujs';
import gsap from 'gsap';
import { SplitText } from '../vendor/gsap-esm/SplitText';
import { ScrollTrigger } from '../vendor/gsap-esm/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    this.FX = {
      content: new SplitText(this.DOM.view, {
        type: 'words',
        wordsClass: 'tw-invisible',
      }),
    };

    gsap.delayedCall(window.readyDelay, () => {
      this.fx();
    });
  }

  fx() {
    this.animate();
    this.reveal();
  }

  animate() {
    this.animation = gsap.timeline();

    this.animation
      .add([
        gsap.fromTo(
          this.FX.content.words,
          {
            autoAlpha: 0,
          },
          {
            autoAlpha: 1,
            ease: 'quart.out',
            duration: 0.1,
            stagger: {
              each: 0.1,
            },
            immediateRender: false,
          }
        ),
      ])
      .add(
        [
          gsap.fromTo(
            this.FX.content.words,
            {
              y: 100,
            },
            {
              y: 0,
              ease: 'quart.out',
              duration: 1,
              stagger: 0.05,
              immediateRender: false,
            }
          ),
        ],
        '<'
      );
  }

  reveal() {
    this.st = ScrollTrigger.create({
      animation: this.animation,
      trigger: this.DOM.view,
      start: 'top 70%',
    });
  }

  destroy() {
    this.st.kill(true);
  }
}
